// app下载

const routers = [
  {
    path: '/download-app',
    name: 'downloadApp',
    component: () =>
      import(/* webpackChunkName: "download-app" */'./pages/download-app'),
  },
  {
    path: '/general-report/:source/:uuid/',
    name: 'generalReport',
    component: () =>
      import(/* webpackChunkName: "anonymous-call" */'./pages/common-report'),
  },
];

export default routers;
